import React from 'react';

export const ClockIcon = () => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="time-clock-circle" d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.2,17.221a1.016,1.016,0,0,1-1.413.062l-4.959-4.546A1,1,0,0,1,10.5,12V6.5a1,1,0,0,1,2,0v5.06l4.634,4.248a1,1,0,0,1,.066,1.414Z" />
        </svg>
    )
}